import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { numberFormatterInternational } from '../../../../app/utils/telephonyHelpers';
import * as conversationActions from '../../../conversation/actions/conversation';
import { notificationActions } from '../../../notifications/actions/notification';
import { searchUsers } from '../../../telephony/api/telephony';
import { transferToNumberActions } from '../actions/transferToNumberModal';
import * as transferToNumberAPI from '../api/transferToNumber';

const { conversationWsClose, conversationWsAgentUnassigned } =
  conversationActions.actions;

const { notificationAdd, notificationRemoveByType } = notificationActions;

const {
  transferToNumberAssistedRequest,
  transferToNumberAssistedRequestSucceeded,
  transferToNumberAssistedRequestFailed,

  transferToNumberBlindRequest,
  transferToNumberBlindRequestSucceeded,
  transferToNumberBlindRequestFailed,

  transferToNumberAssistedResolve,
  transferToNumberAssistedResolveSucceeded,
  transferToNumberAssistedResolveFailed,

  transferToNumberGetUsersByQuery,
  transferToNumberGetUsersByQuerySucceeded,
  transferToNumberGetUsersByQueryFailed,

  transferToNumberRequestStop,
  transferToNumberModalClose,
} = transferToNumberActions;

export const transferToNumberModal = [
  takeEvery(
    transferToNumberAssistedRequest.toString() as any,
    apiGenWithPromise(
      transferToNumberAPI.assistedTransferRequest,
      transferToNumberAssistedRequestSucceeded,
      transferToNumberAssistedRequestFailed,
    ),
  ),

  takeEvery(
    transferToNumberBlindRequest.toString() as any,
    apiGenWithPromise(
      transferToNumberAPI.blindTransferRequest,
      transferToNumberBlindRequestSucceeded,
      transferToNumberBlindRequestFailed,
    ),
  ),

  takeEvery(
    transferToNumberAssistedResolve.toString() as any,
    apiGenWithPromise(
      transferToNumberAPI.assistedTransferResolve,
      transferToNumberAssistedResolveSucceeded,
      transferToNumberAssistedResolveFailed,
    ),
  ),

  takeEvery(
    transferToNumberGetUsersByQuery.toString() as any,
    apiGenWithPromise(
      searchUsers,
      transferToNumberGetUsersByQuerySucceeded,
      transferToNumberGetUsersByQueryFailed,
    ),
  ),
  takeLatest(conversationWsClose.toString(), conversationCloseGen),

  takeEvery(
    conversationWsAgentUnassigned.toString(),
    conversationWsAgentUnassignedGen,
  ),
];

function apiGenWithPromise(
  apiCall: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiCall, action.payload);
      result.meta.request = action.payload;
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction({ action: action, result: result }));
    }
  };
}

// Close conversation.
function* conversationCloseGen(action) {
  const csid = action.payload.params.csid;
  const getConversations = (state) => state.conversations;
  const conversationsState = yield select(getConversations);

  // Check if our current conversation in conversation view is the conversation that got closed.
  const foundMetaConversation = conversationsState.metaConversations.find(
    (metaC) => metaC.conversation.id === csid,
  );
  if (foundMetaConversation) {
    yield put(transferToNumberModalClose());
    yield put(
      notificationRemoveByType({ type: `transfer_assisted_option_${csid}` }),
    ); // Close any transfer assisted option notification.

    const getTransferToNumber = (state) => state.transferToNumber;
    const transferToNumberState = yield select(getTransferToNumber);

    const foundTransferRequest = transferToNumberState.transferRequests.find(
      (request) => request.metaConversation.conversation.id === csid,
    );

    if (foundTransferRequest) {
      yield put(
        notificationRemoveByType({ type: `conversation_closed_${csid}` }),
      );

      let author: any = null;
      let name: any = null;
      if (
        foundMetaConversation.conversation.authors &&
        foundMetaConversation.conversation.authors[
          action.payload.params.closed_by
        ]
      ) {
        author =
          foundMetaConversation.conversation.authors[
            action.payload.params.closed_by
          ];
        if (author.name) {
          name = author.name;
        } else if (author.phone_number) {
          name = numberFormatterInternational({
            phoneNumber: author.phone_number,
          });
        } else if (author.email) {
          name = author.email;
        }
      }
      const notificationOption = {
        type: `conversation_closed_${csid}`,
        title: 'Conversation was closed',
        text: `${csid} was closed ` + (name ? `by ${name}` : ''),
        className: 'default',
        icon: 'i-info',
      };

      yield put(notificationAdd(notificationOption));
      yield put(transferToNumberRequestStop({ csid: csid }));
    }
  }
}

// Unassign conversation.
function* conversationWsAgentUnassignedGen(action) {
  const csid = action.payload.csid;

  const getConversations = (state) => state.conversations;
  const conversationsState = yield select(getConversations);

  const foundMetaConversation = conversationsState.metaConversations.find(
    (metaC) => metaC.conversation.id === csid,
  );

  if (foundMetaConversation) {
    const getTransferToAgent = (state) => state.transferToAgent;
    const transferToAgentState = yield select(getTransferToAgent);

    yield put(transferToNumberModalClose());

    const foundTransferRequest = transferToAgentState.transferRequests.find(
      (request) => request.metaConversation.conversation.id === csid,
    );

    if (foundTransferRequest) {
      yield put(transferToNumberRequestStop({ csid: csid }));
    }
  }
}
